import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';

import './style.scss';

interface Options {
    name: string;
    checked?: boolean;
    onChange: () => void;
    label: string;
    disabled?: boolean;
}

const Radio = ({ name, checked, onChange, label, disabled }: Options) => {
    return (
        <div className="field">
            <label className={`items-center gap-2 custom-radio ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
                <input type="radio" name={name} checked={checked} onChange={onChange} />
                {checked ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
                {label}
            </label>
        </div>
    );
};

export default Radio;
